export const EMAIL_ADDRESS_REGEX =
  /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;

// パスワードで利用可能な記号は下記の32種類
// ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ , > < ' : ; | _ ~ ` = + -
// refs. https://docs.aws.amazon.com/ja_jp/cognito/latest/developerguide/user-pool-settings-policies.html
export const PASSWORD_SYMBOL_REGEX = /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/g;
